import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 40 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "g",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      clipPath: "url(#Double-Tick-Circle-Filled_svg__a)",
      clipRule: "evenodd"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.707-11.293a1 1 0 0 0-1.414-1.414L11 13.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z" }),
    /* @__PURE__ */ React.createElement("path", { d: "M28 22c5.523 0 10-4.477 10-10S33.523 2 28 2 18 6.477 18 12s4.477 10 10 10m4.707-11.293a1 1 0 0 0-1.414-1.414L27 13.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z" })
  ),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "Double-Tick-Circle-Filled_svg__a" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h40v24H0z" })))
);
var SvgDoubleTickCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DoubleTickCircleFilled_default = SvgDoubleTickCircleFilled;

export { DoubleTickCircleFilled_default as default };
